import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import Select from "react-select";
import swal from "sweetalert";
import "./CreateShelf.css";
import alertify from "alertifyjs";
import logUserActivity from "../utils/logUserActivity"; 

function Createshelf() {
  const [listing, setListing] = useState([]);
  const [listOfShelf, setlistOfShelf] = useState([]);
  const [shelfno, setshelfno] = useState("");
  const [rackno, setrackno] = useState("");
  const [Warehouse, setWarehouse] = useState("Warehouse 1");
  const [title, settitle] = useState("");
  const [Medium, setMedium] = useState("");
  const [mrp, setMrp] = useState("");
  const [capacity, setcapacity] = useState("");
  const [presentquantity, setpresentquantity] = useState("");
  const [type, settype] = useState("");
  const [autoFilled, setAutoFilled] = useState(false);
  const [selectedSKU, setSelectedSKU] = useState(null);
  const [emptyspace, setemptyspace] = useState("");
  const [edition, setedition] = useState("");
 
  const [filteredRackOptions, setFilteredRackOptions] = useState([]);
  const [filteredShelfOptions, setFilteredShelfOptions] = useState([]);


  const validateForm = () => Boolean(
    rackno &&
    Warehouse &&
    shelfno &&
    selectedSKU &&
    title &&
    Medium &&
    edition &&
    mrp &&
    capacity &&
    presentquantity &&
    type
  );
  

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getCreateshelf`).then((response) => {
      setlistOfShelf(response.data);
    });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`).then((response) => {
      setListing(response.data);
    });
  }, []);

  useEffect(() => {
    const selectedSKUDetails = listing.find(
      (skuu) => skuu.sku === selectedSKU?.value
    );
    const calculatedEmptySpace = capacity - presentquantity;
    setemptyspace(calculatedEmptySpace);

    if (selectedSKUDetails) {
      settitle(selectedSKUDetails.title);
      setMedium(selectedSKUDetails.Medium);
      setedition(selectedSKUDetails.edition);
     
      setMrp(selectedSKUDetails.mrp);
      setAutoFilled(true);
    } else {
      settitle("");
      setMedium("");
      setedition("");
    
      setMrp("");
    }
  }, [selectedSKU, listing, capacity, presentquantity]);

  useEffect(() => {
    const filteredShelves = shelfOptions.filter((option) =>
      option.value.startsWith(`${rackno}-`)
    );
    setFilteredShelfOptions(filteredShelves);
  }, [rackno]);

  useEffect(() => {
    setFilteredRackOptions(rackOptions);
  }, [Warehouse]);

  const rackOptions = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
    { value: "24", label: "24" },
    { value: "25", label: "25" },
    { value: "26", label: "26" },
    { value: "27", label: "27" },
    { value: "28", label: "28" },
    { value: "29", label: "29" },
    { value: "30", label: "30" },
    { value: "31", label: "31" },
    { value: "32", label: "32" },
    { value: "33", label: "33" },
    { value: "34", label: "34" },
    { value: "35", label: "35" },
    { value: "36", label: "36" },
    { value: "37", label: "37" },
    { value: "38", label: "38" },
    { value: "39", label: "39" },
    { value: "40", label: "40" },
    { value: "41", label: "41" },
    { value: "42", label: "42" },
    { value: "43", label: "43" },
    { value: "44", label: "44" },
    { value: "45", label: "45" },






























  ];

  const shelfOptions = [
    { value: "1-A", label: "1-A" },
    { value: "1-B", label: "1-B" },
    { value: "1-C", label: "1-C" },
    { value: "1-D", label: "1-D" },
    { value: "1-E", label: "1-E" },
    { value: "1-F", label: "1-F" },
    { value: "1-G", label: "1-G" },



























































































    { value: "2-A", label: "2-A" },
    { value: "2-B", label: "2-B" },
    { value: "2-C", label: "2-C" },
    { value: "2-D", label: "2-D" },
    { value: "2-E", label: "2-E" },
    { value: "2-F", label: "2-F" },
    { value: "2-G", label: "2-G" },

    { value: "3-A", label: "3-A" },
    { value: "3-B", label: "3-B" },
    { value: "3-C", label: "3-C" },
    { value: "3-D", label: "3-D" },
    { value: "3-E", label: "3-E" },
    { value: "3-F", label: "3-F" },
    { value: "3-G", label: "3-G" },

    { value: "4-A", label: "4-A" },
    { value: "4-B", label: "4-B" },
    { value: "4-C", label: "4-C" },
    { value: "4-D", label: "4-D" },
    { value: "4-E", label: "4-E" },
    { value: "4-F", label: "4-F" },
    { value: "4-G", label: "4-G" },

    { value: "5-A", label: "5-A" },
    { value: "5-B", label: "5-B" },
    { value: "5-C", label: "5-C" },
    { value: "5-D", label: "5-D" },
    { value: "5-E", label: "5-E" },
    { value: "5-F", label: "5-F" },
    { value: "5-G", label: "5-G" },

    { value: "6-A", label: "6-A" },
    { value: "6-B", label: "6-B" },
    { value: "6-C", label: "6-C" },
    { value: "6-D", label: "6-D" },
    { value: "6-E", label: "6-E" },
    { value: "6-F", label: "6-F" },
    { value: "6-G", label: "6-G" },

    { value: "7-A", label: "7-A" },
    { value: "7-B", label: "7-B" },
    { value: "7-C", label: "7-C" },
    { value: "7-D", label: "7-D" },
    { value: "7-E", label: "7-E" },
    { value: "7-F", label: "7-F" },
    { value: "7-G", label: "7-G" },

    { value: "8-A", label: "8-A" },
    { value: "8-B", label: "8-B" },
    { value: "8-C", label: "8-C" },
    { value: "8-D", label: "8-D" },
    { value: "8-E", label: "8-E" },
    { value: "8-F", label: "8-F" },
    { value: "8-G", label: "8-G" },

    { value: "9-A", label: "9-A" },
    { value: "9-B", label: "9-B" },
    { value: "9-C", label: "9-C" },
    { value: "9-D", label: "9-D" },
    { value: "9-E", label: "9-E" },
    { value: "9-F", label: "9-F" },
    { value: "9-G", label: "9-G" },

    { value: "10-A", label: "10-A" },
    { value: "10-B", label: "10-B" },
    { value: "10-C", label: "10-C" },
    { value: "10-D", label: "10-D" },
    { value: "10-E", label: "10-E" },
    { value: "10-F", label: "10-F" },
    { value: "10-G", label: "10-G" },

    { value: "11-A", label: "11-A" },
    { value: "11-B", label: "11-B" },
    { value: "11-C", label: "11-C" },
    { value: "11-D", label: "11-D" },
    { value: "11-E", label: "11-E" },
    { value: "11-F", label: "11-F" },
    { value: "11-G", label: "11-G" },

    { value: "12-A", label: "12-A" },
    { value: "12-B", label: "12-B" },
    { value: "12-C", label: "12-C" },
    { value: "12-D", label: "12-D" },
    { value: "12-E", label: "12-E" },
    { value: "12-F", label: "12-F" },
    { value: "12-G", label: "12-G" },

    { value: "13-A", label: "13-A" },
    { value: "13-B", label: "13-B" },
    { value: "13-C", label: "13-C" },
    { value: "13-D", label: "13-D" },
    { value: "13-E", label: "13-E" },
    { value: "13-F", label: "13-F" },
    { value: "13-G", label: "13-G" },

    { value: "14-A", label: "14-A" },
    { value: "14-B", label: "14-B" },
    { value: "14-C", label: "14-C" },
    { value: "14-D", label: "14-D" },
    { value: "14-E", label: "14-E" },
    { value: "14-F", label: "14-F" },
    { value: "14-G", label: "14-G" },

    { value: "15-A", label: "15-A" },
    { value: "15-B", label: "15-B" },
    { value: "15-C", label: "15-C" },
    { value: "15-D", label: "15-D" },
    { value: "15-E", label: "15-E" },
    { value: "15-F", label: "15-F" },
    { value: "15-G", label: "15-G" },

    { value: "16-A", label: "16-A" },
    { value: "16-B", label: "16-B" },
    { value: "16-C", label: "16-C" },
    { value: "16-D", label: "16-D" },
    { value: "16-E", label: "16-E" },
    { value: "16-F", label: "16-F" },
    { value: "16-G", label: "16-G" },

    { value: "17-A", label: "17-A" },
    { value: "17-B", label: "17-B" },
    { value: "17-C", label: "17-C" },
    { value: "17-D", label: "17-D" },
    { value: "17-E", label: "17-E" },
    { value: "17-F", label: "17-F" },
    { value: "17-G", label: "17-G" },

    { value: "18-A", label: "18-A" },
    { value: "18-B", label: "18-B" },
    { value: "18-C", label: "18-C" },
    { value: "18-D", label: "18-D" },
    { value: "18-E", label: "18-E" },
    { value: "18-F", label: "18-F" },
    { value: "18-G", label: "18-G" },

    { value: "19-A", label: "19-A" },
    { value: "19-B", label: "19-B" },
    { value: "19-C", label: "19-C" },
    { value: "19-D", label: "19-D" },
    { value: "19-E", label: "19-E" },
    { value: "19-F", label: "19-F" },
    { value: "19-G", label: "19-G" },

    { value: "20-A", label: "20-A" },
    { value: "20-B", label: "20-B" },
    { value: "20-C", label: "20-C" },
    { value: "20-D", label: "20-D" },
    { value: "20-E", label: "20-E" },
    { value: "20-F", label: "20-F" },
    { value: "20-G", label: "20-G" },

    { value: "21-A", label: "21-A" },
    { value: "21-B", label: "21-B" },
    { value: "21-C", label: "21-C" },
    { value: "21-D", label: "21-D" },
    { value: "21-E", label: "21-E" },
    { value: "21-F", label: "21-F" },
    { value: "21-G", label: "21-G" },

    { value: "22-A", label: "22-A" },
    { value: "22-B", label: "22-B" },
    { value: "22-C", label: "22-C" },
    { value: "22-D", label: "22-D" },
    { value: "22-E", label: "22-E" },
    { value: "22-F", label: "22-F" },
    { value: "22-G", label: "22-G" },

    { value: "23-A", label: "23-A" },
    { value: "23-B", label: "23-B" },
    { value: "23-C", label: "23-C" },
    { value: "23-D", label: "23-D" },
    { value: "23-E", label: "23-E" },
    { value: "23-F", label: "23-F" },
    { value: "23-G", label: "23-G" },

    { value: "24-A", label: "24-A" },
    { value: "24-B", label: "24-B" },
    { value: "24-C", label: "24-C" },
    { value: "24-D", label: "24-D" },
    { value: "24-E", label: "24-E" },
    { value: "24-F", label: "24-F" },
    { value: "24-G", label: "24-G" },

    { value: "25-A", label: "25-A" },
    { value: "25-B", label: "25-B" },
    { value: "25-C", label: "25-C" },
    { value: "25-D", label: "25-D" },
    { value: "25-E", label: "25-E" },
    { value: "25-F", label: "25-F" },
    { value: "25-G", label: "25-G" },

    { value: "26-A", label: "26-A" },
    { value: "26-B", label: "26-B" },
    { value: "26-C", label: "26-C" },
    { value: "26-D", label: "26-D" },
    { value: "26-E", label: "26-E" },
    { value: "26-F", label: "26-F" },
    { value: "26-G", label: "26-G" },

    { value: "27-A", label: "27-A" },
    { value: "27-B", label: "27-B" },
    { value: "27-C", label: "27-C" },
    { value: "27-D", label: "27-D" },
    { value: "27-E", label: "27-E" },
    { value: "27-F", label: "27-F" },
    { value: "27-G", label: "27-G" },

    { value: "28-A", label: "28-A" },
    { value: "28-B", label: "28-B" },
    { value: "28-C", label: "28-C" },
    { value: "28-D", label: "28-D" },
    { value: "28-E", label: "28-E" },
    { value: "28-F", label: "28-F" },
    { value: "28-G", label: "28-G" },

    { value: "29-A", label: "29-A" },
    { value: "29-B", label: "29-B" },
    { value: "29-C", label: "29-C" },

    { value: "30-A", label: "30-A" },
    { value: "30-B", label: "30-B" },
    { value: "30-C", label: "30-C" },

    { value: "31-A", label: "31-A" },
    { value: "31-B", label: "31-B" },
    { value: "31-C", label: "31-C" },

    { value: "32-A", label: "32-A" },
    { value: "32-B", label: "32-B" },
    { value: "32-C", label: "32-C" },

    { value: "33-A", label: "33-A" },
    { value: "33-B", label: "33-B" },
    { value: "33-C", label: "33-C" },

    { value: "34-A", label: "34-A" },
    { value: "34-B", label: "34-B" },
    { value: "34-C", label: "34-C" },

    { value: "35-A", label: "35-A" },
    { value: "35-B", label: "35-B" },
    { value: "35-C", label: "35-C" },

    { value: "36-A", label: "36-A" },
    { value: "36-B", label: "36-B" },
    { value: "36-C", label: "36-C" },

    { value: "37-A", label: "37-A" },
    { value: "37-B", label: "37-B" },
    { value: "37-C", label: "37-C" },

    { value: "38-A", label: "38-A" },
    { value: "38-B", label: "38-B" },
    { value: "38-C", label: "38-C" },

    { value: "39-A", label: "39-A" },
    { value: "39-B", label: "39-B" },
    { value: "39-C", label: "39-C" },

    { value: "40-A", label: "40-A" },
    { value: "40-B", label: "40-B" },
    { value: "40-C", label: "40-C" },

    { value: "41-A", label: "41-A" },
    { value: "41-B", label: "41-B" },
    { value: "41-C", label: "41-C" },

    { value: "42-A", label: "42-A" },
    { value: "42-B", label: "42-B" },
    { value: "42-C", label: "42-C" },

    { value: "43-A", label: "43-A" },
    { value: "43-B", label: "43-B" },
    { value: "43-C", label: "43-C" },

    { value: "44-A", label: "44-A" },
    { value: "44-B", label: "44-B" },
    { value: "44-C", label: "44-C" },

    { value: "45-A", label: "45-A" },
    { value: "45-B", label: "45-B" },
    { value: "45-C", label: "45-C" },
  ];

  const typeOptions = [
    { value: "good", label: "Good" },
    { value: "bad", label: "Bad" },
  ];

  const skuOptions = listing.map((skuu) => ({
    value: skuu.sku,
    label: skuu.sku,
  }));


const createUser = async () => {
  if (!validateForm()) {
    swal({
      title: "All fields are required",
      icon: "error",
    });
    return;
  }

  const skuValue = selectedSKU ? selectedSKU.value.toString() : "";

  const shelvesWithSameShelfNo = listOfShelf.filter(
    (shelf) => shelf.shelfno === shelfno
  );
  const hasSameSKU = shelvesWithSameShelfNo.some(
    (shelf) => shelf.sku === skuValue
  );

  if (hasSameSKU) {
    alertify(
      "A shelf with the same SKU already exists for this Shelf Number. Please choose a different SKU."
    );
    return;
  }

  try {
    await Axios.post(`${INVENTORY_API_BASE_URL}/postCreateshelf`, {
      shelfno,
      Warehouse,
      rackno,
      sku: skuValue,
      title,
      Medium,
      edition,
      mrp,
      capacity,
      presentquantity,
      type,
      emptyspace,
    });

   
    await logUserActivity("CREATE_SHELF", {
      shelfno,
      Warehouse,
      rackno,
      sku: skuValue,
      title,
      Medium,
      edition,
      mrp,
      capacity,
      presentquantity,
      type,
      emptyspace,
    });

    swal({
      title: "Shelf Created",
      icon: "success",
    });
    window.location.reload();
  } catch (error) {
    console.error("Error creating shelf:", error);
    swal({
      title: "Error",
      text: "Shelf creation failed.",
      icon: "error",
    });
  }
};


  return (
    <main className="create-shelf-page">
      <div className="create-shelf-page__inner">
        <header className="create-shelf-hero">
          <div>
            <p className="create-shelf-eyebrow"><span aria-hidden="true" /> Inventory <b>/</b> Storage setup</p>
            <h1>Create shelf</h1>
            <p className="create-shelf-hero__description">
              Set a warehouse location, assign an item, and define its storage capacity.
            </p>
          </div>
          <span className="create-shelf-status"><i aria-hidden="true">+</i> New location</span>
        </header>

        <section className="create-shelf-card" aria-labelledby="create-shelf-title">
          <div className="create-shelf-card__header">
            <div className="create-shelf-card__heading">
              <span className="create-shelf-card__step" aria-hidden="true">01</span>
              <div>
                <h2 id="create-shelf-title">Shelf configuration</h2>
                <p>Enter the location and inventory details for this shelf.</p>
              </div>
            </div>
            <p className="create-shelf-required"><span aria-hidden="true">*</span> Required fields</p>
          </div>

          <form className="create-shelf-form">
            <section className="create-shelf-section" aria-labelledby="create-shelf-location">
              <div className="create-shelf-section__heading">
                <span className="create-shelf-section__icon" aria-hidden="true">⌖</span>
                <div>
                  <h3 id="create-shelf-location">Shelf location</h3>
                </div>
              </div>
              <div className="create-shelf-grid">
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-warehouse">Warehouse <em>*</em></label>
                  <Select
                    inputId="create-shelf-warehouse"
                    className="create-shelf-select"
                    classNamePrefix="create-shelf-select"
                    options={[
                      { value: "Warehouse 1", label: "Warehouse 1" },
                    ]}
                    onChange={(selectedOption) => setWarehouse(selectedOption.value)}
                    value={[
                      { value: "Warehouse 1", label: "Warehouse 1" },
                    ].find((option) => option.value === Warehouse) || null}
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-rack">Rack number <em>*</em></label>
                  <Select
                    inputId="create-shelf-rack"
                    className="create-shelf-select"
                    classNamePrefix="create-shelf-select"
                    options={filteredRackOptions}
                    onChange={(option) => setrackno(option.value)}
                    value={{ value: rackno, label: rackno }}
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-shelf">Shelf number <em>*</em></label>
                  <Select
                    inputId="create-shelf-shelf"
                    className="create-shelf-select"
                    classNamePrefix="create-shelf-select"
                    options={filteredShelfOptions}
                    name="shelfno"
                    required
                    onChange={(selectedOption) => setshelfno(selectedOption.value)}
                    value={filteredShelfOptions.find((option) => option.value === shelfno) || null}
                  />
                </div>
              </div>
            </section>

            <section className="create-shelf-section create-shelf-section--inventory" aria-labelledby="create-shelf-inventory">
              <div className="create-shelf-section__heading">
                <span className="create-shelf-section__icon create-shelf-section__icon--inventory" aria-hidden="true">▦</span>
                <div>
                  <h3 id="create-shelf-inventory">Inventory details</h3>
                  <p>Select an item and set its quantity information.</p>
                </div>
              </div>
              <div className="create-shelf-grid create-shelf-grid--inventory">
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-sku">SKU <em>*</em></label>
                  <Select
                    inputId="create-shelf-sku"
                    className="create-shelf-select"
                    classNamePrefix="create-shelf-select"
                    options={skuOptions}
                    name="sku"
                    required
                    onChange={(selectedOption) => setSelectedSKU(selectedOption)}
                    value={selectedSKU}
                  />
                </div>
                <div className="create-shelf-field create-shelf-field--title">
                  <label htmlFor="create-shelf-item-title">Item title <em>*</em></label>
                  <textarea
                    id="create-shelf-item-title"
                    className="create-shelf-input create-shelf-input--textarea"
                    name="title"
                    required="required"
                    value={title}
                    onChange={(event) => settitle(event.target.value)}
                    readOnly={autoFilled}
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-medium">Medium <em>*</em></label>
                  <input
                    id="create-shelf-medium"
                    type="text"
                    className="create-shelf-input"
                    name="skualotted"
                    required="required"
                    value={Medium}
                    onChange={(event) => setMedium(event.target.value)}
                    readOnly={autoFilled}
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-edition">Edition <em>*</em></label>
                  <input
                    id="create-shelf-edition"
                    type="text"
                    className="create-shelf-input"
                    name="skualotted"
                    required="required"
                    value={edition}
                    onChange={(event) => setedition(event.target.value)}
                    readOnly={autoFilled}
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-mrp">MRP <em>*</em></label>
                  <input
                    id="create-shelf-mrp"
                    type="text"
                    className="create-shelf-input"
                    name="mrp"
                    required="required"
                    value={mrp}
                    readOnly
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-capacity">Capacity <em>*</em></label>
                  <input
                    id="create-shelf-capacity"
                    type="text"
                    className="create-shelf-input"
                    name="capacity"
                    required="required"
                    value={capacity}
                    onChange={(event) => setcapacity(event.target.value)}
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-present">Present quantity <em>*</em></label>
                  <input
                    id="create-shelf-present"
                    type="text"
                    className="create-shelf-input"
                    name="presentquantity"
                    required="required"
                    value={presentquantity}
                    onChange={(event) => setpresentquantity(event.target.value)}
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-empty">Empty space <em>*</em></label>
                  <input
                    id="create-shelf-empty"
                    type="text"
                    className="create-shelf-input"
                    name="emptyspace"
                    required="required"
                    value={emptyspace}
                    onChange={(event) => setemptyspace(event.target.value)}
                  />
                </div>
                <div className="create-shelf-field">
                  <label htmlFor="create-shelf-type">Inventory type <em>*</em></label>
                  <Select
                    inputId="create-shelf-type"
                    className="create-shelf-select"
                    classNamePrefix="create-shelf-select"
                    options={typeOptions}
                    name="type"
                    required
                    onChange={(selectedOption) => settype(selectedOption.value)}
                    value={typeOptions.find((option) => option.value === type) || null}
                  />
                  <span className="create-shelf-field__hint">Choose Good or Bad stock.</span>
                </div>
              </div>
            </section>

            <div className="create-shelf-form__footer">
              <p>Review the selected location and item before saving.</p>
              <button className="create-shelf-submit" type="submit" onClick={createUser}>
                <span aria-hidden="true">✓</span> Save shelf
              </button>
            </div>
          </form>
        </section>
      </div>
    </main>
  );
}

export default Createshelf;
